/* 🤖 this file was generated by svg-to-ts */
export const matIconOpenInFull: {
  name: 'open-in-full';
  data: string;
} = {
  name: 'open-in-full',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M21 11V3h-8l3.29 3.29-10 10L3 13v8h8l-3.29-3.29 10-10z"/></svg>`
};
